import {
  computed,
  defineStore,
  storeFactory,
  useSupabase,
  type GetterType,
} from "#imports";
import type { QueryData } from "@supabase/supabase-js";

export type Category = GetterType<ReturnType<typeof useCategories>["getById"]>;

export const useCategories = defineStore("categories", () => {
  const supabase = useSupabase();

  const selectCategories = () =>
    supabase
      .from("categories")
      // infinite recursion when vue crosses a JSON because of bad JSON typing from Supabase, don't select JSONB fields
      .select(`id, name, description, icon, url_slug, is_public`)
      //      .order("parent_id", { nullsFirst: true })
      .order("name", { ascending: true })
      .throwOnError();

  type RawCategory = QueryData<ReturnType<typeof selectCategories>>[number];

  const { dataById, fetchFactory, getById, getByIds } =
    storeFactory<RawCategory>(
      "categories",
      async (payload) => await selectCategories().in("id", payload),
    );

  const {
    metadata: metadataCategories,
    fetch: fetchCategories,
    result: categories,
  } = fetchFactory<null>(async () => await selectCategories());

  /** Resolve category names and slugs to categories */
  const findCategoriesFromSlugs = (slugs: string[]) =>
    computed(() =>
      slugs.map(
        (slug) =>
          Object.values(categories.value!).find(
            (category) => category.url_slug === slug || category.name === slug,
          )!,
      ),
    );

  return {
    dataById,

    getById,
    getByIds,

    metadataCategories,
    fetchCategories,
    categories,

    findCategoriesFromSlugs,
  };
});
